export const ReceptionDashboardOption = {
	name: [
		{ value: 76, label: "Total OPD" },
		{ value: 12, label: "Amount" },
		{ value: 30, label: "Today OPD" },
		{ value: 40, label: "Doctor wise" },
	],
	title: "Reception Dashboard",
};
